import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('emailListStore', 'marketingSmsManagementStore')
@observer
class SearchResult extends Component {
  state = {
  }
  componentDidMount() {
  }
  handleDelete = (record) => {
    const {emailListStore, marketingSmsManagementStore} = this.props
    const { generateID } = marketingSmsManagementStore
    emailListStore.onClearAddressAction({
      "sourceType": record?.sourceType,
      "taskGroupId": generateID,
      "id": record?.id
    }).then(res=> {
      if (res?.data?.code === 0) {
        emailListStore.onStatisticsAction({
          "taskGroupId": generateID,
        })
      }
    })
  }
  handlePageChange = (page, pageSize) => {
    const {emailListStore} = this.props
    emailListStore.onChangeAddressPageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {emailListStore, t} = this.props
    const {pageNoAddress, pageSizeAddress, itemCountAddress, addressList, sourceTypeList} = emailListStore
    const pagination = getPaginationConfig(pageNoAddress, pageSizeAddress, itemCountAddress, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(addressList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} style={{marginTop: 0, paddingTop: 0}}>
          <Table.Column title={t(`emailSend.emailAddress`)} dataIndex="email" key="email" ellipsis={true} render={(text, record) => (
            <div style={record?.isValid === 1 ? {color: 'rgb(255, 51, 51)'} : {}}>
              {text}
            </div>
          )}  />
          <Table.Column title={t(`marketingManagement.dataSource`)} dataIndex="sourceType" key="sourceType" ellipsis={true} render={(text, record) => (
            sourceTypeList?.find(a=> a?.code===text)?.name
          )} />
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleDelete(record)}title={t(`general.delete`)}>{t(`general.delete`)}</Button>
            </>
          )} />
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
